@for (reaction of reactionsDataWithTooltip; track trackByReaction($index, reaction)) {
  <rt-reaction-button
    [reaction]="reaction.reaction"
    [counter]="reaction.count"
    [isActive]="reaction.currentUserReacted"
    rtTooltip
    [rtTooltipTemplate]="tooltipTemplate"
    [rtTooltipMaxWidth]="400"
    [rtTooltipHasTextAlignCenter]="true"
    (click)="toggle(reaction.reaction)"
  />
  <ng-template #tooltipTemplate>
    <span [innerHTML]="reaction.tooltip"></span>
  </ng-template>
}
@if (showLikeButton) {
  <rt-like-button (click)="toggleLike()" />
}
<rt-add-reaction-button (select)="toggle($event)" />
<ng-container [ngTemplateOutlet]="projectedContentTpl()" />
